<script lang="ts">
import { defineComponent } from "vue";
import type { RenderContext } from "vue";

export default defineComponent({
  functional: true,
  props: {
    if: { type: Boolean, default: false }
  },
  render(h, { props, data, children }: RenderContext) {
    if (props.if) {
      return h("loading", {
        props: data.attrs
      });
    } else {
      return children;
    }
  }
});
</script>
